import * as R from 'ramda'
import { API_CONST } from '../middlewares/api'

import { handleActions, createAction } from 'redux-actions'
import { fetchingState } from '../../helpers/hocs'
import {abTestInit} from './../../abtest/abtest'

const initial = {
    userName: '',
    userID: null,
    clickTime: null,
    clickedLink: null,
    __data: {}
}

const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])
const getAbtestingActions = generateActions('auth/info/getAbtest')

//экшен для ab-тестирования
export const setUserAbTest = createAction(
    API_CONST,
    (data = {}) => ({
      params: data,
      method: 'POST',
      url: 'abtest',
      actions: getAbtestingActions
    })
)

export default handleActions({

    [getAbtestingActions[0]]: state => ({ ...state, settings: null, error: null }),
    [getAbtestingActions[2]]: (state, { payload }) => ({ ...state, settings: null, error: payload.message.response.data.error }),
    [getAbtestingActions[1]]: (state, { payload }) => ({ ...state, settings: payload }),
}, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/abtest.js